module.exports = __webpack_public_path__ + "img/video-icon.0ed3953c.jpg";